/* Centilmen - ana ekrana eklenebilir uygulama davranislari */
(function () {
  if (window.__uygulama) return;
  window.__uygulama = true;

  var ANAHTAR = 'centilmen-uyg-banner-kapali';
  var uygulamaModu = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  var ua = navigator.userAgent || '';
  var ios = /iphone|ipad|ipod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var android = /android/i.test(ua);
  var uygulamaIciTarayici = /instagram|fbav|fban|tiktok|line\/|twitter/i.test(ua);
  var iosSafari = ios && /safari/i.test(ua) && !/crios|fxios|edgios/i.test(ua);
  var mobil = ios || android;

  function oku(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function yaz(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  var stil = document.createElement('style');
  stil.textContent =
    '.uyg-banner{position:fixed;left:12px;right:12px;bottom:12px;z-index:2147483000;display:flex;align-items:center;gap:12px;' +
    'background:#111;color:#fff;border-radius:14px;padding:12px 12px 12px 12px;box-shadow:0 10px 30px rgba(0,0,0,.25);' +
    'font-family:Jost,-apple-system,BlinkMacSystemFont,sans-serif;transform:translateY(140%);transition:transform .35s ease;max-width:520px;margin:0 auto}' +
    '.uyg-banner.is-acik{transform:translateY(0)}' +
    '.uyg-banner img{width:44px;height:44px;border-radius:10px;flex:0 0 44px;border:1px solid rgba(255,255,255,.15)}' +
    '.uyg-banner-metin{flex:1;min-width:0;line-height:1.35}' +
    '.uyg-banner-metin strong{display:block;font-size:13px;font-weight:600;letter-spacing:.06em}' +
    '.uyg-banner-metin span{display:block;font-size:11.5px;color:rgba(255,255,255,.75)}' +
    '.uyg-banner-btn{flex:0 0 auto;background:#fff;color:#111;border:0;border-radius:8px;padding:9px 14px;font-size:11.5px;font-weight:600;letter-spacing:.08em;cursor:pointer;font-family:inherit}' +
    '.uyg-banner-kapat{flex:0 0 auto;background:none;border:0;color:rgba(255,255,255,.6);font-size:20px;line-height:1;padding:4px 2px;cursor:pointer}' +
    '.uyg-ios-ipucu{position:fixed;inset:0;z-index:2147483001;background:rgba(0,0,0,.55);display:flex;align-items:flex-end;justify-content:center;padding:16px}' +
    '.uyg-ios-kutu{background:#fff;color:#111;border-radius:16px;padding:22px 20px 18px;max-width:420px;width:100%;font-family:Jost,-apple-system,sans-serif;text-align:center}' +
    '.uyg-ios-kutu h3{margin:0 0 14px;font-size:15px;font-weight:600;letter-spacing:.06em}' +
    '.uyg-ios-kutu ol{text-align:left;margin:0 0 16px;padding-left:20px;font-size:13.5px;line-height:1.9}' +
    '.uyg-ios-kutu svg{width:16px;height:16px;vertical-align:-3px}' +
    '.uyg-ios-kutu button{background:#111;color:#fff;border:0;border-radius:8px;padding:11px 22px;font-size:12px;font-weight:600;letter-spacing:.08em;font-family:inherit}' +
    '.uyg-geri{position:fixed;left:12px;bottom:calc(env(safe-area-inset-bottom,0px) + 16px);z-index:2147482999;width:38px;height:38px;border-radius:50%;' +
    'background:rgba(255,255,255,.92);border:1px solid rgba(0,0,0,.08);box-shadow:0 2px 10px rgba(0,0,0,.12);display:flex;align-items:center;justify-content:center;cursor:pointer}' +
    '.uyg-geri svg{width:18px;height:18px}';
  document.head.appendChild(stil);

  /* --- Uygulama modunda: geri butonu (iPhone'da tarayici cubugu olmadigi icin) --- */
  if (uygulamaModu) {
    document.documentElement.classList.add('uygulama-modu');
    var anaSayfa = location.pathname === '/' || location.pathname === '';
    if (!anaSayfa) {
      var geri = document.createElement('button');
      geri.type = 'button';
      geri.className = 'uyg-geri';
      geri.setAttribute('aria-label', 'Geri');
      geri.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
      geri.addEventListener('click', function () {
        if (history.length > 1) history.back(); else location.href = '/';
      });
      if (document.body) document.body.appendChild(geri);
      else document.addEventListener('DOMContentLoaded', function () { document.body.appendChild(geri); });
    }
    return; // uygulama icindeyken yukleme banneri gosterme
  }

  /* --- Tarayicida: "Uygulamayi yukle" banneri (sadece telefonda) --- */
  if (!mobil || uygulamaIciTarayici) return;
  var kapaliZaman = parseInt(oku(ANAHTAR) || '0', 10);
  if (kapaliZaman && Date.now() - kapaliZaman < 7 * 24 * 60 * 60 * 1000) return; // kapatildiysa 7 gun gosterme

  var ertelenmisIstek = null;
  var ikonUrl = (document.querySelector('link[rel="apple-touch-icon"]') || {}).href || '';

  function bannerGoster(butonMetni, tikla) {
    if (document.querySelector('.uyg-banner')) return;
    var b = document.createElement('div');
    b.className = 'uyg-banner';
    b.setAttribute('role', 'dialog');
    b.setAttribute('aria-label', 'Centilmen uygulamasi');
    b.innerHTML =
      (ikonUrl ? '<img src="' + ikonUrl + '" alt="">' : '') +
      '<div class="uyg-banner-metin"><strong>CENTİLMEN UYGULAMASI</strong><span>Ana ekranına ekle, tek dokunuşla alışveriş yap.</span></div>' +
      '<button type="button" class="uyg-banner-btn">' + butonMetni + '</button>' +
      '<button type="button" class="uyg-banner-kapat" aria-label="Kapat">&times;</button>';
    document.body.appendChild(b);
    requestAnimationFrame(function () { requestAnimationFrame(function () { b.classList.add('is-acik'); }); });
    b.querySelector('.uyg-banner-btn').addEventListener('click', tikla);
    b.querySelector('.uyg-banner-kapat').addEventListener('click', function () { yaz(ANAHTAR, String(Date.now())); kapat(); });
  }
  function kapat() {
    var b = document.querySelector('.uyg-banner');
    if (!b) return;
    b.classList.remove('is-acik');
    setTimeout(function () { b.remove(); }, 400);
  }

  function iosIpucu() {
    var paylas = '<svg viewBox="0 0 24 24" fill="none" stroke="#007aff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12M8 7l4-4 4 4"/><path d="M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"/></svg>';
    var arti = '<svg viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="2" stroke-linecap="round"><rect x="3" y="3" width="18" height="18" rx="4"/><path d="M12 8v8M8 12h8"/></svg>';
    var k = document.createElement('div');
    k.className = 'uyg-ios-ipucu';
    k.innerHTML =
      '<div class="uyg-ios-kutu"><h3>ANA EKRANA EKLE</h3><ol>' +
      '<li>Alttaki <strong>Paylaş</strong> ' + paylas + ' simgesine dokun</li>' +
      '<li>Listeden <strong>Ana Ekrana Ekle</strong> ' + arti + ' seç</li>' +
      '<li>Sağ üstte <strong>Ekle</strong>\'ye dokun</li></ol>' +
      '<button type="button">ANLADIM</button></div>';
    document.body.appendChild(k);
    function kapatIpucu() { k.remove(); }
    k.querySelector('button').addEventListener('click', kapatIpucu);
    k.addEventListener('click', function (e) { if (e.target === k) kapatIpucu(); });
  }

  // Android / Chrome: tarayicinin kendi yukleme penceresi
  window.addEventListener('beforeinstallprompt', function (e) {
    e.preventDefault();
    ertelenmisIstek = e;
    setTimeout(function () {
      bannerGoster('YÜKLE', function () {
        if (!ertelenmisIstek) return;
        ertelenmisIstek.prompt();
        ertelenmisIstek.userChoice.then(function (sonuc) {
          if (sonuc && sonuc.outcome === 'accepted') yaz(ANAHTAR, String(Date.now() + 3650 * 864e5));
          ertelenmisIstek = null;
          kapat();
        });
      });
    }, 4000);
  });
  window.addEventListener('appinstalled', function () { yaz(ANAHTAR, String(Date.now() + 3650 * 864e5)); kapat(); });

  // iPhone Safari: yukleme penceresi yok, adim adim tarif goster
  if (iosSafari) {
    var basla = function () {
      setTimeout(function () { bannerGoster('EKLE', function () { kapat(); iosIpucu(); }); }, 4000);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla); else basla();
  }
})();
